<div class="container me-quick-test">
    <div *ngIf="data && imageBlock">
        <div class="row d-flex flex-column-reverse flex-lg-row">
            <div class="col-md-6 col-xs-12 me-quick-test--block" >
                <div class="me-quick-test--title hero" [innerHTML]="imageBlock.headline | storyblokRichtext">
                </div>
                <div *ngIf="imageBlock.hero" class="me-quick-test--line"></div>
                <div class="me-quick-test--description hero" [innerHTML]="imageBlock.text | storyblokRichtext"></div>
            </div>
            <div class="col-md-6 col-xs-12">
                <div class="me-quick-test--image">
                    <img src="{{imageBlock.image.filename}}" >
                </div>
            </div>
        </div>
        <div class="me-quick-test--body">
            <div class="me-quick-test--body--text" [innerHTML]="data.firstSection | storyblokRichtext:replaceText"></div>
        </div>
        <ng-container *ngIf="!showHelpCard">
            <div class="me-quick-test--suggest">
                <div class="me-quick-test--suggest--text" [innerHTML]="data.secondSection | storyblokRichtext"></div>
            </div>
        </ng-container>
        <ng-container *ngIf="showHelpCard">
            <div class="me-quick-test--suggest">
                <div class="me-quick-test--suggest--body">
                    <div class="me-quick-test--suggest--body--recomment">{{ 'Our recommendation' | translate }}</div>
                    <div class="me-quick-test--suggest--body--text" [innerHTML]="data.secondSection | storyblokRichtext"></div>
                </div>
                <me-quick-test-help-card></me-quick-test-help-card>
            </div>
        </ng-container>
    </div>
</div>